import { nonCopyToClipboardAccountIdLabels } from './accountIdConfigTooltip';

export function copyAccountIdToClipboard(accountId) {
  if (nonCopyToClipboardAccountIdLabels.includes(accountId)) return;

  navigator.clipboard.writeText(accountId);
}

export function shouldShowCopyAccountIdButton(accountIdLabel) {
  return !nonCopyToClipboardAccountIdLabels.includes(accountIdLabel);
}
